<template>
    <tr v-if="isMobile">
        <td>
            <ul class="flex-content">
                <div class="content d-flex justify-space-between" style="width:100%;">
                    <label>Admission Date:</label>
                    <li class="flex-item" data-label="Calories">
                        {{
                            formatDate(tableItems.ADMI_D)
                                ? formatDate(tableItems.ADMI_D)
                                : "-"
                        }}
                    </li>
                </div>

                <div class="content d-flex justify-space-between" style="width:100%;">
                    <label>Release Date:</label>
                    <li class="flex-item" data-label="Calories">
                        {{
                            formatDate(tableItems.RELE_D)
                                ? formatDate(tableItems.RELE_D)
                                : "-"
                        }}
                    </li>
                </div>

                <div class="content d-flex justify-space-between" style="width:100%;">
                    <label>Availment Type:</label>
                    <li class="flex-item" data-label="Calories">
                        {{ tableItems.ADMI_D == null ? "Out-Patient" : "In-patient" }}
                    </li>
                </div>

                <div class="content d-flex justify-space-between" style="width:100%;">
                    <label>Hospital/Clinic Name:</label>
                    <li class="flex-item" data-label="Calories">
                        {{ tableItems.HOSP ? tableItems.HOSP : "-" }}
                    </li>
                </div>

                <div class="content d-flex justify-space-between" style="width:100%;">
                    <label>Doctor Name:</label>
                    <li class="flex-item" data-label="Calories">
                        {{ tableItems.DOC ? tableItems.DOC : "-" }}
                    </li>
                </div>

                <div class="content d-flex justify-space-between" style="width:100%;">
                    <label>Hospital Bill:</label>
                    <li class="flex-item" data-label="Calories">
                        {{ tableItems.BILL_T == "H" ? tableItems.ACTU_A : "-" }}
                    </li>
                </div>

                <div class="content d-flex justify-space-between" style="width:100%;">
                    <label>Professional Fee:</label>
                    <li class="flex-item" data-label="Calories">
                        {{ tableItems.BILL_T == "P" ? tableItems.ACTU_A : "-" }}
                    </li>
                </div>

                <div class="content d-flex justify-space-between" style="width:100%;">
                    <label>Diagnosis:</label>
                    <li class="flex-item" data-label="Calories">
                        {{ tableItems.DIAG ? tableItems.DIAG : "-" }}
                    </li>
                </div>
                <!--
        <div class="content d-flex justify-space-between" style="width:100%;">
          <label>Procedure:</label>
          <li class="flex-item" data-label="Calories">
            {{ tableItems.ACTI ? tableItems.ACTI : "-" }}
          </li>
        </div>
        -->
            </ul>
        </td>
    </tr>
</template>

<script>
import { moment } from '../../../utils/date-shim'
export default {
    props: ['isMobile', 'tableItems'],
    methods: {
        formatDate(date) {
            if (date == null) {
                return '-'
            } else {
                return moment(date).utcOffset('+0800').format('MMM DD,YYYY')
            }
        }
    }
}
</script>

<style scoped>
@media (max-width: 968px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .content {
    margin-bottom: 10px;
  }
  .flex-content {
    padding: 0;
    margin: 10px auto;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  .flex-item {
    padding: 5px;
    width: 100%;
    height: 40px;
    text-align: right;
  }

  label {
    width: 60%;
    font-weight: bold;
    padding: 5px;
  }
}
</style>
